export default function() {
    this.loadCurrentUserData()
    this.isMounted = true
}
